import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ResetPasswordRequest = () => {
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState(""); // 사용자 입력 인증번호
  const [codeSent, setCodeSent] = useState(false); // 인증번호 전송 여부
  const [codeVerified, setCodeVerified] = useState(false); // 인증번호 확인 여부
  const [userId, setUserId] = useState(null); // 서버로부터 받은 user_id
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  const navigate = useNavigate(); // 페이지 이동을 위한 useNavigate 훅

  // 전화번호로 인증번호 전송
  const sendVerificationCode = async () => {
    try {
      const response = await axios.post(
        "http://35.192.131.111/user/send/code/",
        {
          phone_number: phoneNumber,
        }
      );

      if (response.data.result) {
        setCodeSent(true);
        setError(null);
        alert("인증번호가 전송되었습니다.");
      } else {
        setError("인증번호 전송에 실패했습니다.");
      }
    } catch (error) {
      setError("인증번호 전송에 실패했습니다.");
    }
  };

  // 인증번호 확인
  const verifyCode = async () => {
    try {
      const response = await axios.post(
        "http://35.192.131.111/user/verify/code/",
        {
          phone_number: phoneNumber,
          verification_code: Number(verificationCode),
        }
      );

      if (response.data.result) {
        setCodeVerified(true);
        setError(null);
        alert("인증이 완료되었습니다.");
      } else {
        setError("인증번호가 올바르지 않습니다.");
      }
    } catch (error) {
      setError("인증번호 확인에 실패했습니다.");
    }
  };

  // 비밀번호 재설정 요청
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!codeVerified) {
      setError("먼저 인증번호 확인을 완료해주세요.");
      return;
    }

    try {
      const response = await axios.post(
        "http://35.192.131.111/user/password/reset/",
        {
          username,
          phone_number: phoneNumber,
        }
      );

      if (response.data.result) {
        setUserId(response.data.user_id); // 서버에서 받은 user_id를 저장
        setMessage(response.data.message);
        setError(null);

        // ResetPassword 페이지로 이동 및 userId 전달
        navigate("/resetpassword", {
          state: { userId: response.data.user_id },
        });
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      setError("비밀번호 재설정 요청에 실패했습니다.");
    }
  };

  return (
    <div className="reset-password-request">
      <h2>비밀번호 찾기</h2>
      {error && <p className="error-message">{error}</p>}
      {message && <p className="message">{message}</p>}

      {!userId && (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>아이디</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="아이디를 입력하세요"
              required
            />
          </div>

          <div className="form-group">
            <label>전화번호</label>
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="전화번호를 입력하세요"
              required
            />
            <button type="button" onClick={sendVerificationCode}>
              인증번호 전송
            </button>
          </div>

          {/* 인증번호 입력 및 확인 */}
          {codeSent && (
            <div className="form-group">
              <label>인증번호</label>
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                placeholder="인증번호를 입력하세요"
                required
              />
              <button type="button" onClick={verifyCode}>
                인증번호 확인
              </button>
            </div>
          )}

          <button type="submit" disabled={!codeVerified}>
            비밀번호 재설정 요청
          </button>
        </form>
      )}
    </div>
  );
};

export default ResetPasswordRequest;
